import React, { useEffect } from "react";

const SocialBubbles = () => {
  // Add the chat widget script when component mounts
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://chatagent.maibotapp.com/embed.js";
    script.defer = true;
    script.setAttribute("data-bot-id", "254e59d9-838c-4cd2-9dd4-322fe66b1e10");
    document.body.appendChild(script);

    return () => {
      // Clean up script on component unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="fixed bottom-28 right-4 z-50 flex flex-col gap-4">
      {/* Zalo bubble */}
      <a 
        href="https://zalo.me/2617993914803033984" 
        target="_blank"
        rel="noopener noreferrer"
        className="w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center hover:opacity-90 transition-opacity"
        aria-label="Chat with us on Zalo"
      >
        <img src="/logo/zalo.svg" alt="Zalo" className="w-6 h-6" />
      </a>

      {/* Messenger bubble */}
      <a 
        href="https://www.messenger.com/t/497297643469349" 
        target="_blank"
        rel="noopener noreferrer"
        className="w-12 h-12 rounded-full bg-[#0084ff] text-white shadow-lg flex items-center justify-center hover:opacity-90 transition-opacity"
        aria-label="Chat with us on Messenger"
      >
        <svg viewBox="0 0 36 36" className="w-6 h-6" fill="currentColor">
          <path d="M17.999 1.072c-9.322 0-16.928 7.113-16.928 15.928 0 5.067 2.158 9.439 5.604 12.373v6.555l5.944-2.951c1.703.474 3.515.725 5.38.725 9.32 0 16.93-7.113 16.93-16.702 0-8.816-7.61-15.928-16.93-15.928zm1.434 21.076-4.762-4.751-8.748 4.751 9.634-9.624 4.763 4.75 8.748-4.75-9.635 9.624z"></path>
        </svg>
      </a>
    </div>
  );
};

export default SocialBubbles; 